"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Heading = _interopRequireDefault(require("../Heading"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var H5 = (0, _styledComponents.default)(_Heading.default).withConfig({
  displayName: "H5",
  componentId: "sc-1o270om-0"
})(_templateObject());
H5.propTypes = _Heading.default.propTypes;
H5.defaultProps = (0, _extends2.default)({}, _Heading.default.defaultProps, {
  tagName: 'h5'
});
H5.displayName = 'H5';
var _default = H5;
exports.default = _default;
module.exports = exports.default;